import DownloadIcon from 'assets/icons/download.svg';
import DownloadMenuButton, {
	type DownloadMenuItem,
} from 'components/collection/download-menu-button';
import IconButton from 'components/controls/buttons/icon-button';
import { humanizeFileSize } from 'helpers/helpers';
import trackClickButton from 'lib/analytics/trackClickButton';
import type { VntanaDownloadOption } from 'lib/vntana/downloads';
import styles from './download-button.module.scss';

export const ModalDownloadButton = ({
	imageUrl,
	disabled,
	objectID,
	objectTitle,
}: IProps) => {
	const handleDownloadClick = () => {
		trackClickButton({
			buttonClicked: 'download_image',
			contentType: 'Collection Objects',
			contentBlock: 'Image Viewer',
			contentName: objectTitle,
			objectId: objectID,
		});
		window.open(imageUrl, '_blank');
	};

	return (
		<IconButton
			label="Download Image"
			icon={<DownloadIcon />}
			onClick={handleDownloadClick}
			disabled={disabled}
		></IconButton>
	);
};

export const Modal3DDownloadButton = ({
	downloadOptions,
	objectID,
	objectTitle,
}: I3DProps) => {
	const items: DownloadMenuItem[] = downloadOptions.map((option) => ({
		href: option.url,
		id: option.format,
		label: 'Download 3D model',
		meta: `${option.extension}, ${humanizeFileSize(option.sizeBytes, 1)}`,
		onClick: () =>
			trackClickButton({
				buttonClicked: 'download_3d_model',
				contentType: 'Collection Objects',
				contentBlock: '3D Viewer',
				contentName: objectTitle,
				objectId: objectID,
			}),
	}));

	return (
		<DownloadMenuButton
			buttonClassName={styles.viewerDownloadButton}
			buttonLabel="Download 3D model"
			iconOnly={true}
			items={items}
			menuAlign="left"
			menuDirection="up"
			wrapperClassName={styles.viewerDownloadWrapper}
		/>
	);
};

interface IProps {
	objectID: string | number;
	objectTitle: string;
	imageUrl: string;
	disabled: boolean;
}

interface I3DProps {
	objectID?: string | number;
	objectTitle: string;
	downloadOptions: VntanaDownloadOption[];
}
